/* eslint-disable @reatom/unit-naming-rule */

import { onConnect, type Atom } from '@reatom/framework'

import { Set } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network/atoms'
import { reatomResource, reatomSetComputed } from '@root/shared/lib'

import { fetchUserTradingAnalyticsRequestAction } from './analytics-requests'

import type { UserTradingAnalyticsPeriod } from '../models/user-trading-analytics-period'
import type { ProfileWallet } from '@root/entities/profile/model/profile-wallet'
import type { DelugeId } from '@root/entities/user-short/model'

export const reatomUserTradingAnalytics = ({
  delugeId,
  periodAtom,
  selectedWalletsAtom,
  wallets,
}: {
  delugeId: DelugeId
  periodAtom: Atom<UserTradingAnalyticsPeriod>
  selectedWalletsAtom: Atom<ReadonlyArray<ProfileWallet>>
  wallets: ReadonlyArray<ProfileWallet>
}) => {
  const selectedWalletAddresses = reatomSetComputed((ctx) => {
    const wallets = ctx.spy(selectedWalletsAtom)
    return Set.create(wallets.map((wallet) => wallet.address))
  })

  const stateAtom = reatomResource(
    (ctx) => {
      const network = ctx.spy(selectedNetworkAtom)
      const period = ctx.spy(periodAtom)
      const walletAddresses = ctx.spy(selectedWalletAddresses)

      return fetchUserTradingAnalyticsRequestAction(ctx, {
        delugeId,
        network,
        period,
        walletAddresses: [...walletAddresses.values()],
      })
    },
    {
      name: 'reatomUserTradingAnalytics',
      loadOnConnect: false,
    },
  )

  onConnect(stateAtom, (ctx) => {
    if (wallets.length > 0) {
      stateAtom.run(ctx)
    }
  })

  return stateAtom
}

export type UserTradingAnalyticsResource = ReturnType<
  typeof reatomUserTradingAnalytics
>
